const palette = {
    primary: {
      main: 'rgba(24, 116, 210, 1)', // A dark blue for header, buttons, etc.
      contrastText: '#ffffff', // White text to contrast with blue.
    },
    secondary: {
      main: '#ff6f00', // Orange accent for important buttons or interaction points.
    },
    background: {
      default: '#ffffff', // Light grey for the general background to give an official feel.
      paper: '#ffffff', // White for cards or important areas to stand out.
    },
    text: {
      primary: '#333333', // Dark grey text for readability.
      secondary: '#666666', // Lighter grey for secondary text.
    },
  };


  export default palette